module.exports = __webpack_public_path__ + "img/features-03-image-01.531dccf2.png";